import Home from '../views/Home'
import Commercial from '../views/Commercial'
import Documentary from '../views/Documentary'
import Music from '../views/Music'
import Narrative from '../views/Narrative'
import Bio from '../views/Bio'
import Login from '../views/Login'
import EditMovies from '../views/EditMovies'
import PageNotFound from '../views/404'
import MovieForm from '../views/MovieForm'
import EditProjects from '../views/EditProjects'
import ProjectsForm from '../views/ProjectsForm'
import Still from '../views/Still'
import Project from '../views/Project'

import RouterHelper from '../helpers/RouterHelper'

export const routes = [
	{
		path: '/',
		name: 'home',
		component: Home
	},
	{
		path: '/commercial',
		name: 'commercial',
		component: Commercial
	},
	{
		path: '/documentary',
		name: 'documentary',
		component: Documentary
	},
	{
		path: '/music',
		name: 'music',
		component: Music
	},
	{
		path: '/narrative',
		name: 'narrative',
		component: Narrative
	},
	{
		path: '/bio',
		name: 'bio',
		component: Bio
	},
	{
		path: '/login',
		name: 'login',
		component: Login
	},
	{
		path: '/still',
		component: RouterHelper,
		children: [
			{
				path: '',
				name: 'still',
				component: Still
			},
			{
				path: ':project',
				component: Project
			}
		]
	},
	{
		path: '/edit-movies',
		component: RouterHelper,
		meta: {
			admin: true
		},
		children: [
			{
				path: '',
				name: 'edit-movies',
				component: EditMovies
			},
			{
				path: ':movie',
				component: MovieForm
			}
		]
	},
	{
		path: '/edit-projects',
		component: RouterHelper,
		meta: {
			admin: true
		},
		children: [
			{
				path: '',
				name: 'edit-projects',
				component: EditProjects
			},
			{
				path: ':project',
				component: ProjectsForm
			}
		]
	},
	{
		path: '*',
		name: 'PageNotFound',
		component: PageNotFound
	}
]
